import { getNextSibling } from "./get-siblings.js";

var gridBlockCollapse = document.querySelectorAll('.js-grid-block-collapse');

gridBlockCollapse.forEach((elem) => {
  let button = getNextSibling(elem, '.js-grid-block-view-all');

  elem.addEventListener('show.bs.collapse', function () {
    button.textContent = "Collapse";
  });
  elem.addEventListener('hide.bs.collapse', function () {
    button.textContent = "View All";
  })
});
